var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYahooCalendar = function SvgYahooCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4853 5.61219L7.82799 12.3233L5.20299 5.61219H0.699707L5.66049 17.2902L3.85252 21.5H8.26674L14.8719 5.61219H10.4853ZM15.426 11.9773C14.8862 11.9773 14.3586 12.1374 13.9098 12.4373C13.461 12.7371 13.1112 13.1634 12.9046 13.662C12.6981 14.1607 12.644 14.7094 12.7493 15.2388C12.8546 15.7682 13.1146 16.2545 13.4962 16.6361C13.8779 17.0178 14.3642 17.2777 14.8935 17.383C15.4229 17.4883 15.9717 17.4343 16.4703 17.2277C16.969 17.0212 17.3952 16.6714 17.6951 16.2226C17.995 15.7738 18.155 15.2462 18.155 14.7064C18.155 14.348 18.0844 13.9931 17.9473 13.662C17.8101 13.3309 17.6091 13.0301 17.3557 12.7767C17.1023 12.5233 16.8014 12.3222 16.4703 12.1851C16.1392 12.0479 15.7843 11.9773 15.426 11.9773ZM18.4991 0.5L14.1397 10.9752H19.0517L23.3938 0.5H18.4991Z",
    fill: "#410093"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYahooCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yahoo-calendar.20c9f139.svg";
export { ForwardRef as ReactComponent };